import { ColorLabel } from '../../services/entities/impl/blfApi/schemas/stage';

const colorMap: Record<ColorLabel, string> = {
  gray: '#BBBBBB',
  green: '#82BB41',
  yellow: '#FFD35E',
  pink: '#FF76CA',
  red: '#E15353',
  purple: '#B93AF4',
  blue: '#458FFF',
};

const UNKNOWN = '#333' as const;

/**
 * Takes a ColorLabel and returns the corresponding color in a hex code string
 * @param colorLabel
 * @returns Hex color code string
 */
export function getColorForColorLabel(colorLabel: ColorLabel): string {
  return colorMap[colorLabel] ?? UNKNOWN;
}
